"use client";
import { useTranslations } from "@zapier/i18n";

import { Text } from "@zapier/design-system";
import {
  Group,
  Panel,
  Separator,
  useDefaultLayout,
} from "react-resizable-panels";
import styles from "./AssetLayout.module.css";
import { AssetLinks } from "./AssetLinks";
import { TrashLink } from "./TrashLink";

import { useEmitAssetSidebarResizeEvent } from "../../../events/useEmitAssetSidebarResizeEvent";

const AutomationsLayout = ({ children }: { children: React.ReactNode }) => {
  const t = useTranslations("asset-layout");
  const { emit: emitResizeEvent } = useEmitAssetSidebarResizeEvent();
  const { defaultLayout, onLayoutChanged } = useDefaultLayout({
    id: "automations-assets-layout",
    storage: localStorage,
  });

  return (
    <>
      <div className={styles.mobileNav}>
        <AssetLinks />
      </div>
      <Group
        className={styles.layout}
        defaultLayout={defaultLayout}
        onLayoutChanged={onLayoutChanged}
      >
        <Panel defaultSize={"15%"} minSize={"10%"} maxSize={"30%"} id="left">
          <div className={styles.sidebar}>
            <div className={styles.header}>
              <Text tag="h2" type="SectionHeader">
                {t("headings.automations")}
              </Text>
            </div>

            <AssetLinks />
            <TrashLink />
          </div>
        </Panel>

        <Separator
          className={styles.resizeHandle}
          aria-label={t("resize-handle.label")}
          onDragEnd={(event) => emitResizeEvent(event.clientX)}
        />

        <Panel className={styles.contentPanel} id="right">
          <div className={styles.content}>{children}</div>
        </Panel>
      </Group>
    </>
  );
};

export default AutomationsLayout;
